module.exports = __webpack_public_path__ + "static/media/man.b5fa038e.svg";